import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useTranslation } from "react-i18next";

import { Hint } from "@/components/ui/hint";
import { BrandLogo } from "@/components/BrandLogo";

interface WrapperProps {
  children: React.ReactNode;
}

export default function Wrapper({ children }: WrapperProps) {
  const { t } = useTranslation();
  return (
    <div className="h-dvh w-full flex items-center justify-center">
      <div className="w-full md:grid place-content-center gap-4 [grid-template-areas:'logo_form''hint_form']">
        <div className="flex items-end justify-center [grid-area:logo] p-6">
          <BrandLogo asLink={false} className="h-12 w-[200px]" />
        </div>

        <div className="flex items-center justify-center [grid-area:form]">
          <Card className="w-96">
            <CardHeader>
              <CardTitle className="text-2xl">{t("signIn.title")}</CardTitle>
            </CardHeader>
            <CardContent>{children}</CardContent>
          </Card>
        </div>

        <div className="flex items-start justify-center [grid-area:hint]">
          <Hint className="w-96 p-6 pr-14">{t("signIn.description")}</Hint>
        </div>
      </div>
    </div>
  );
}
